import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types/api';

export interface ParentNote {
  id?: number;
  parentId?: number;
  sitterId?: number;
  comment?: string;
  updated?: string;
}

const URL = '/v2/parent-notes';

class ParentNoteService {
  static create(
    data: ParentNote,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<ParentNote>> {
    return axios.post(URL, data, config);
  }

  static patch(
    id: number,
    data: ParentNote,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<ParentNote>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { ParentNoteService };
